export default "__VITE_ASSET__BLjKiha5__"